export default {
    downtimeUrl: "https://cl.kodland.tech",
    successPage: {
      title: "¡Felicitaciones! 🎁",
      subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    computer: true,
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
    },
    quizRotateBySteps: {
      1: {
        question:
          "¿Eres padre, madre o hijo? 👀",
        answers: [
        {
          answer: "Padre",
          family_member: "Father",
          event_name: "ab_button_click_q1_dad",
          event_source: "google",
        },
        {
          answer: "Madre",
          family_member: "Mother",
          event_name: "ab_button_click_q1_mom",
          event_source: "google",
        },
        {
          answer: "Hijo",
          family_member: "Child",
          event_name: "ab_button_click_q1_kid",
          event_source: "google",
        },
      ],
      },
      2: {
        question: "¿Cuál es el nivel educativo más alto en tu familia? 🎓",
        answers: [
          {
            answer: "Maestría o superior",
            family_education: "Master_or_higher",
            event_name: "ab_button_click_q3_master",
            event_source: "google",
          },
          {
            answer: "Licenciatura",
            family_education: "Bachelor",
            event_name: "ab_button_click_q3_bachelor",
            event_source: "google",
          },
          {
            answer: "Secundaria",
            family_education: "Secondary",
            event_name: "ab_button_click_q3_secondary",
            event_source: "google",
          },
          {
            answer: "Preparatoria",
            family_education: "Middle_school",
            event_name: "ab_button_click_q3_middle",
            event_source: "google",
          },
        ],
      },
      3: {
        question:
          "¿Cuál es el género de tu hijo/a? 👀",
          answers: [
            {
              answer: "Feminino",
              child_gender: "Female",
              event_name: "ab_button_click_q4_fem",
              event_source: "google",
            },
            {
              answer: "Masculino",
              child_gender: "Man",
              event_name: "ab_button_click_q4_male",
              event_source: "google",
            },
            {
              answer: "No quiero responder",
              child_gender: "No_answer",
              event_name: "ab_button_click_q4_none",
              event_source: "google",
            },
          ],
      },
      4: {
        question: "¿En qué tipo de escuela estudia tu hijo/a? 🍎",
        answers: [
          {
            answer: "Pública",
            school_type: "Public",
            event_name: "ab_button_click_q5_public",
            event_source: "google",
          },
          {
            answer: "Privada",
            school_type: "Private",
            event_name: "ab_button_click_q5_private",
            event_source: "google",
          },
          {
            answer: "Católica",
            school_type: "Catholic",
            event_name: "ab_button_click_q5_catholic",
            event_source: "google",
          },
        ],
      },
      5: {
        question: "¿En qué tipo de actividades extracurriculares participa tu hijo? ⚽",
        answers: [
          {
            answer: "Clases de idiomas",
            child_classes: "Language",
            event_name: "ab_button_click_q6_language",
            event_source: "google",
          },
          {
            answer: "Clases culturales",
            child_classes: "Culture",
            event_name: "ab_button_click_q6_culture",
            event_source: "google",
          },
          {
            answer: "Clases de deporte",
            child_classes: "Sport",
            event_name: "ab_button_click_q6_sport",
            event_source: "google",
          },
          {
            answer: "Clases de música",
            child_classes: "Music",
            event_name: "ab_button_click_q6_music",
            event_source: "google",
          },
          {
            answer: "Otro",
            child_classes: "Other",
            event_name: "ab_button_click_q6_other",
            event_source: "google",
          },
          {
            answer: "Ninguno",
            child_classes: "None",
            event_name: "ab_button_click_q6_none",
            event_source: "google",
          },
        ],
      },
      6: {
        question:
          "¿Tiene su hijo/a experiencia previa en educación en línea? 🌐",
        answers: [
        {
          answer: "Sí",
          online_education_exp: "Yes",
          event_name: "ab_button_click_q7_yes",
          event_source: "google",
        },
        {
          answer: "No",
          online_education_exp: "No",
          event_name: "ab_button_click_q7_no",
          event_source: "google",
        },
      ],
      },
    },
  };